import React, { useCallback, useState } from 'react';
import { safeColor } from './utils';
import ToggleButton from '../ToggleButton';
import { Pipette } from '@wix/wix-ui-icons-common';
import { DataHooks } from './constants';

export const EyeDropper = ({
  eyeDropperLabel,
  allowEmpty,
  onChange,
}: {
  eyeDropperLabel: string;
  allowEmpty: boolean;
  onChange: (color: ReturnType<typeof safeColor>) => void;
}) => {
  const [eyeDropperActive, setEyeDropperActive] = useState(false);

  const supportsEyeDropper =
    typeof window !== 'undefined' && 'EyeDropper' in window;

  if (!supportsEyeDropper) {
    return null;
  }

  const handleEyeDropper = useCallback(async () => {
    try {
      setEyeDropperActive(true);
      const eyeDropper = new window.EyeDropper!();
      const result = await eyeDropper.open();

      if (result && result.sRGBHex) {
        const _color = safeColor(result.sRGBHex, allowEmpty);
        if (_color) {
          onChange(_color);
        }
      }
    } catch (error) {
      if (error instanceof DOMException) {
        if (error.name === 'AbortError') {
          // User cancelled - this is expected behavior, no action needed
          return;
        }
        console.error('EyeDropper error:', error.name, error.message);
      } else {
        console.error('Unexpected error:', error);
      }
    } finally {
      setEyeDropperActive(false);
    }
  }, [allowEmpty, onChange, setEyeDropperActive]);

  return (
    <ToggleButton
      size="medium"
      onClick={handleEyeDropper}
      dataHook={DataHooks.eyeDropper}
      labelValue={eyeDropperLabel}
      selected={eyeDropperActive}
    >
      <Pipette />
    </ToggleButton>
  );
};
